module.exports = __webpack_public_path__ + "img/2_262.adcc7a3f.png";